import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppComponent } from '../app.component';

import { AuthGuard } from '../auth.guard';
import { SharedModule } from '../shared/modules/shared.module';
import { HomeService } from './services/home.service';

@NgModule({
  imports: [FormsModule, SharedModule, RouterModule],
  declarations: [],
  exports: [],
  providers: [AppComponent, AuthGuard, HomeService]
})
export class HomeModule { }
